export default __webpack_public_path__ + "static/media/culture_EP6.e1f474d7.png";